import { render, staticRenderFns } from "./RegistrantModal.vue?vue&type=template&id=ba1a7db4&scoped=true"
import script from "./RegistrantModal.vue?vue&type=script&lang=js"
export * from "./RegistrantModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RegistrantModal.vue?vue&type=style&index=1&id=ba1a7db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1a7db4",
  null
  
)

export default component.exports